// Module
var code = "<google-redirect></google-redirect>";
// Exports
module.exports = code;